<template>
  <el-backtop :target="target" :visibility-height="300" :right="24" :bottom="14">
    <div class="top-btn" >
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div>
  </el-backtop>
</template>

<script>
export default {
name: "BackToTop",
  props: {
    target: String
  }
}
</script>

<style scoped>
.top-btn{
  width: 36px;
  height: 36px;
  border-radius: 50%;
  text-align: center;
  line-height: 34px;
  background: #409eff;
  color: #ffffff;
}

/*.top-btn:hover {*/
/*  background-color: #9aaabf;*/
/*  color: #ffffff;*/
/*}*/

</style>
